import { PriceFeedData } from 'src/common/api-clients/swarm/types'
import { useQuery } from '@tanstack/react-query'
import { getPriceFeeds } from '../../api-clients/swarm'
import useActiveOrDefaultChain from '../../hooks/web3/useActiveOrDefaultChain'
import { mapBy } from '../../utils/collections/mapBy'
import { TOKENS_WITH_PRICE_FEEDS } from './consts'

export type UsePriceFeedsData = Map<string, PriceFeedData>

export const usePriceFeeds = (contractAddresses: string[]) => {
  const chain = useActiveOrDefaultChain()

  const { data: priceFeeds, ...rest } = useQuery({
    queryFn: async () => {
      const data = await getPriceFeeds(chain.id, contractAddresses)
      return data
    },
    queryKey: ['price-feeds-prices', chain.id, contractAddresses.join(',')],
    enabled: Boolean(contractAddresses.length),
    select: data => {
      return mapBy(data, 'token_address')
    },
  })

  return {
    priceFeeds: priceFeeds as UsePriceFeedsData,
    ...rest,
  }
}

export const useAllPriceFeeds = () => {
  const { id: chainId } = useActiveOrDefaultChain()

  return usePriceFeeds(Array.from(TOKENS_WITH_PRICE_FEEDS[chainId]))
}
